import React, { PureComponent } from 'react'
import { reportCode } from '../../constants/backendIds'
import DefaultHomeReport from './DefaultHomeReport'
import PowerBiHomeReport from './PowerBiHomeReport'

class Report extends PureComponent {
  componentDidMount () {
    this.props.actions.fetchReportTypeCode()
  }

  componentDidUpdate () {

  }

  getSnapshotBeforeUpdate (prevProps) {
    if ((prevProps.reportTypeCode === null || prevProps.reportTypeCode === undefined) && this.props.reportTypeCode === reportCode.powerbi) {
      this.props.actions.fetchPowerbiConfig()
    }
    return null
  }

  render () {
    const { t, reportTypeCode, powerbiConfig, actions: { powerBiRefreshSession } } = this.props
    const tKey = 'REPORTS.'
    if (reportTypeCode === reportCode.default) {
      return <DefaultHomeReport tKey={tKey} t={t} />
    }

    if (powerbiConfig && Object.keys(powerbiConfig).length > 0) {
      return <PowerBiHomeReport powerbiConfig={powerbiConfig} powerBiRefreshSession={powerBiRefreshSession} />
    }
    return null
  }
}

export default Report
